type SlotCoordinateValue = string | number;

export interface SlotCoordinates {
  x: SlotCoordinateValue;
  y: SlotCoordinateValue;
  z: SlotCoordinateValue;
}

const SLOT_ID_PATTERN =
  /^\s*([^-.,\s]+)\s*[.,-]\s*([^-.,\s]+)\s*[.,-]\s*([^-.,\s]+)\s*$/;
const HYPHENATED_SLOT_ID_PATTERN =
  /^([^-.,\s]+)-([^-.,\s]+)-([^-.,\s]+)$/;

export function isHyphenatedSlotIdentifier(
  value: string | null | undefined
): boolean {
  return HYPHENATED_SLOT_ID_PATTERN.test(value?.trim() ?? "");
}

export function normalizeSlotIdentifier(
  value: string | null | undefined
): string {
  const trimmed = value?.trim() ?? "";

  if (trimmed === "") {
    return "";
  }

  const match = trimmed.match(SLOT_ID_PATTERN);

  if (!match) {
    return trimmed;
  }

  return match.slice(1).join("-");
}

export function formatSlotDisplay(
  value: SlotCoordinates | string | null | undefined
): string {
  if (value == null) {
    return "";
  }

  if (typeof value === "string") {
    return normalizeSlotIdentifier(value);
  }

  const parts = [value.x, value.y, value.z].map((part) => `${part}`.trim());

  if (parts.some((part) => part === "")) {
    return "";
  }

  return parts.join("-");
}
